module.exports = __webpack_public_path__ + "static/media/home-delivery_icon.15ec9c71.svg";